/* eslint-disable no-console */
import firebase from "firebase/app";
import {
	readCCPACookie,
	writeCCPACookie,
	isLandingPage,
} from "@/common/functions";
import {
	API_SERVICE_AUTH,
	SAVEDWORDS_KEYNAME,
	DICTIONARIES,
	PAGES,
	NEWSLETTERS,
} from "@/common/consts";
import axios from "axios";
import Vue from "vue";

function compressList(list) {
	if (!list || !list.length) return { attrs: [], values: [] };
	let attrs = Object.keys(list[0]);
	attrs.sort(); // Attributes are sorted by name to make the output stable.
	let values = list.map((e) => {
		let objArray = Array(attrs.lentgh);
		attrs.forEach((attr, index) => {
			objArray[index] = e[attr];
		});
		return objArray;
	});
	return { attrs, values };
}

function config(idToken) {
	return { headers: { Authorization: `Bearer ${idToken}` } };
}

export default {
	state: {
		loggedIn: false,
		user: {
			data: null,
			usprivacy: "1---",
			savedWords: {},
			preferences: {},
			newslettersSubscription: null,
		},
		isDialogOpen: false,
		isLoggingIn: false,
		logInError: "",
		dialogType: "signUp",
		savedWordButtonClickCounter: 0,
		previouslyLoggedIn: false,
		isSubscriptionDialogOpen: false,
		location: null,
	},
	actions: {
		fetchUser: ({ commit, dispatch }, user) => {
			dispatch("getLocation");
			commit("SET_LOGGED_IN", user !== null);
			if (user) {
				commit("UPDATE_USER", {
					displayName: user.displayName,
					email: user.email,
					picture: user.photoURL,
				});
				dispatch("fetchUserClaims");
				dispatch("getUserSavedWords");
				dispatch("getUserPreference");
				dispatch("getUserNewslettersSubscription");
			} else {
				commit("UPDATE_USER", null);
			}
		},
		fetchUserClaims: ({ commit }) => {
			if (firebase.apps.length) {
				firebase
					.auth()
					.currentUser.getIdTokenResult(true)
					.then((idTokenResult) => {
						let usprivacy =
							idTokenResult.claims &&
							idTokenResult.claims.usprivacy;
						commit("UPDATE_USPRIVACY", usprivacy || "1YNY");
					});
			}
		},
		login: ({ dispatch, commit }) => {
			commit("SET_IS_LOGGING_IN", true);
			commit("SET_LOG_IN_ERROR", null);
			if (firebase.apps.length) {
				firebase
					.auth()
					.setPersistence(firebase.auth.Auth.Persistence.LOCAL)
					.then(() => {
						const provider = new firebase.auth.GoogleAuthProvider();
						provider.addScope("profile");
						provider.addScope("email");

						return firebase.auth().signInWithPopup(provider);
					})
					.then(() => {
						dispatch("closeDialog");
						commit("SET_IS_LOGGING_IN", false);
					})
					.catch((error) => {
						commit("SET_IS_LOGGING_IN", false);
						if (error.code !== "auth/popup-closed-by-user") {
							commit("SET_LOG_IN_ERROR", error.message);
						}
					});
			}
		},
		logout: ({ commit }) => {
			if (firebase.apps.length) {
				firebase
					.auth()
					.signOut()
					.then(() => {
						commit("SET_LOGGED_IN", false);
						commit("setFilter", false, { root: true });
						commit("setSorting", "wordlength", { root: true });
						commit("setDictionary", DICTIONARIES[1], {
							root: true,
						});
						commit("SET_USER_PREFERENCES", {});
						commit("SET_USER_SUBSCRIPTION", null);
					})
					.catch((err) => {
						console.error(err);
					});
			}
		},
		openDialog: ({ commit }, type) => {
			commit("SET_DIALOG_TYPE", type);
			commit("SET_DIALOG_STATE", true);
			commit("SET_COUNTER");
		},
		closeDialog: ({ commit }) => {
			commit("SET_DIALOG_STATE", false);
		},
		transferSavedWords: ({ dispatch }, payload) => {
			const savedWords = payload.map((item) => {
				return { d: item.date, w: item.word };
			});
			dispatch("updateSavedWords", { words: savedWords });
		},
		updateSavedWords({ state, commit, dispatch }, payload) {
			if (firebase.apps.length) {
				firebase
					.auth()
					.currentUser.getIdToken()
					.then((idToken) => {
						if (payload.type === "remove") {
							delete state.user.savedWords[payload.word];
						}

						const storeSavedWords = Object.values(
							state.user.savedWords
						).map((item) => {
							return { d: item.date, w: item.word };
						});

						const words = {
							words: {
								...compressList([
									...storeSavedWords,
									...(payload.words || ""),
								]),
							},
						};

						axios
							.put(
								`${API_SERVICE_AUTH}/saved_words`,
								words,
								config(idToken)
							)
							.then((response) => {
								const { data } = response.data;
								commit(
									"SET_USER_SAVED_WORDS",
									compressList(data.words).values
								);
								localStorage.removeItem(SAVEDWORDS_KEYNAME);
								commit("resetSavedWordsFromLocalStorage", {
									root: true,
								});
							})
							.catch((err) => {
								console.error(err);
							});
					});
			}
		},
		updatePreferences: ({ commit, rootState }) => {
			const groupByPreference = {
				wordlength: "word_length",
				totalpoints: "none",
				allWords: "none",
			};
			if (
				rootState.login.user.preferences.bonus_points !==
					rootState.query.bonuspoints ||
				rootState.login.user.preferences.dictionary !==
					rootState.query.dictionary ||
				rootState.login.user.preferences.group_by !==
					groupByPreference[rootState.query.sortResults]
			) {
				if (firebase.apps.length) {
					firebase
						.auth()
						.currentUser.getIdToken()
						.then((idToken) => {
							const preferences = {
								results_page: {
									dictionary: rootState.query.dictionary,
									group_by:
										groupByPreference[
											rootState.query.sortResults
										],
									bonus_points: rootState.query.bonuspoints,
								},
							};

							axios
								.put(
									`${API_SERVICE_AUTH}/preferences`,
									preferences,
									config(idToken)
								)
								.then(() => {
									commit("SET_USER_PREFERENCES", {
										dictionary: rootState.query.dictionary,
										group_by:
											groupByPreference[
												rootState.query.sortResults
											],
										bonus_points:
											rootState.query.bonuspoints,
									});
								})
								.catch((err) => {
									console.error(err);
								});
						});
				}
			}
		},
		getUserSavedWords: ({ commit, dispatch, rootState }) => {
			commit("setLoadingSavedWords", true, { root: true });

			if (firebase.apps.length) {
				firebase
					.auth()
					.currentUser.getIdToken()
					.then((idToken) => {
						axios
							.get(
								`${API_SERVICE_AUTH}/saved_words`,
								config(idToken)
							)
							.then((response) => {
								const { data } = response.data;
								commit(
									"SET_USER_SAVED_WORDS",
									data.words.values
								);
								if (!rootState.savedWords.length) return;
								dispatch(
									"transferSavedWords",
									rootState.savedWords
								);
							})
							.catch((err) => {
								console.error(err);
							})
							.finally(() =>
								commit("setLoadingSavedWords", false)
							);
					});
			}
		},
		getUserPreference: ({ commit, dispatch, rootState }) => {
			if (firebase.apps.length) {
				firebase
					.auth()
					.currentUser.getIdToken()
					.then((idToken) => {
						axios
							.get(
								`${API_SERVICE_AUTH}/preferences`,
								config(idToken)
							)
							.then((response) => {
								const { data } = response.data;
								const preferences = data.results_page;
								const isUnscramblePage =
									rootState.navigation.current ===
									PAGES.UNSCRAMBLER_RESULTS;
								const groupByPreference = {
									word_length: "wordlength",
									none: isUnscramblePage
										? "totalpoints"
										: "allWords",
								};
								if (preferences) {
									if (
										!isLandingPage(
											rootState.navigation.current
										)
									) {
										commit(
											"setDictionary",
											preferences.dictionary,
											{ root: true }
										);
									}
									commit(
										"setFilter",
										preferences.bonus_points,
										{
											root: true,
										}
									);
									commit(
										"setSorting",
										groupByPreference[preferences.group_by],
										{ root: true }
									);
									commit("SET_USER_PREFERENCES", preferences);
								} else {
									dispatch("updatePreferences");
								}
							})
							.catch((err) => {
								console.error(err);
							});
					});
			}
		},
		getUserNewslettersSubscription: ({ state, commit, dispatch }) => {
			if (firebase.apps.length) {
				firebase
					.auth()
					.currentUser.getIdToken()
					.then((idToken) => {
						axios
							.get(
								`${API_SERVICE_AUTH}/newsletter`,
								config(idToken)
							)
							.then((response) => {
								const { data } = response.data;
								if (data.status) {
									commit(
										"SET_USER_SUBSCRIPTION",
										data.status
									);
								} else {
									state.location === "US"
										? dispatch(
												"toggleNewslettersSubscription",
												NEWSLETTERS.ON
										  )
										: commit(
												"SET_SUBSCRIPTION_DIALOG_STATE",
												true
										  );
								}
							})
							.catch((err) => {
								console.error(err);
							});
					});
			}
		},
		toggleNewslettersSubscription: ({ commit, dispatch }, value) => {
			const params = {
				status: value,
			};
			if (firebase.apps.length) {
				firebase
					.auth()
					.currentUser.getIdToken()
					.then((idToken) => {
						axios
							.put(
								`${API_SERVICE_AUTH}/newsletter`,
								params,
								config(idToken)
							)
							.then((response) => {
								const { data } = response.data;
								commit("SET_USER_SUBSCRIPTION", data.status);
							})
							.catch((err) => {
								console.error(err);
							});
					});
			}
		},
		getLocation({ commit }) {
			axios
				.get(
					"http://ip-api.com/json/?key=AmUN9xAaQALVYu6&fields=countryCode"
				)
				.then((response) => {
					const { data } = response;
					commit("SET_LOCATION", data.countryCode);
				});
		},
	},
	mutations: {
		SET_LOGGED_IN: (state, value) => {
			state.loggedIn = value;
		},
		SET_IS_LOGGING_IN: (state, value) => {
			state.isLoggingIn = value;
		},
		SET_LOG_IN_ERROR: (state, value) => {
			state.logInError = value;
		},
		UPDATE_USER: (state, data) => {
			state.user.data = data;
		},
		UPDATE_USPRIVACY: (state, value) => {
			if (!/^[1][nNyY-][nNyY-][nNyY-]$/.test(value)) return;
			state.user.usprivacy = value;

			// Sync the new value to the 'usprivacy' cookie that is read from the "__uspapi()"
			//console.log(`DEBUG> usprivacy: claim=${value} cookie=${readCCPACookie()}`);
			if (value != readCCPACookie()) {
				writeCCPACookie(value);
				//console.log(`DEBUG> Updated cookie: ${readCCPACookie()}`);
			}
		},
		SET_DIALOG_STATE: (state, value) => {
			state.isDialogOpen = value;
		},
		SET_SUBSCRIPTION_DIALOG_STATE: (state, value) => {
			state.isSubscriptionDialogOpen = value;
		},
		SET_DIALOG_TYPE: (state, value) => {
			state.dialogType = value;
		},
		SET_COUNTER: (state) => {
			state.savedWordButtonClickCounter += 1;
		},
		SET_USER_SAVED_WORDS: (state, value) => {
			state.user.savedWords = value.reduce((acc, item) => {
				acc[item[1]] = {
					date: item[0],
					word: item[1],
				};
				return acc;
			}, {});
		},
		SET_USER_PREFERENCES: (state, value) => {
			Vue.set(state.user, "preferences", value);
		},
		SET_PREVIOUSLY_LOGGED_IN: (state, value) => {
			state.previouslyLoggedIn = value;
		},
		SET_LOCATION: (state, value) => {
			state.location = value;
		},
		SET_USER_SUBSCRIPTION: (state, value) => {
			state.user.newslettersSubscription = value;
		},
	},
	getters: {
		loggedIn: (state) => state.loggedIn,
		user: (state) => state.user,
		imgProfile: (state) => state.user.data.picture,
		initials: (state) => {
			return state.user.data.displayName
				.split(" ")
				.map((word) => word[0].toUpperCase())
				.join("");
		},
		usprivacy: (state) => state.user.usprivacy,
		isDialogOpen: (state) => state.isDialogOpen,
		dialogType: (state) => state.dialogType,
		savedWordButtonClickCounter: (state) =>
			state.savedWordButtonClickCounter,
		userPreferences: (state) => state.user.preferences,
		previouslyLoggedIn: (state) => state.previouslyLoggedIn,
	},
};
